/**
 * Sanitizes error messages and objects to hide Supabase URLs
 * Replaces Supabase project URLs with the custom domain
 */

const SUPABASE_PROJECT_REF = 'zkqcqgjbsigjdwzmnwmp';
const CUSTOM_DOMAIN = 'api.northreports.com';

export function sanitizeError(error: any): any {
  if (!error) return error;

  // Handle string errors
  if (typeof error === 'string') {
    return error
      .replace(new RegExp(`${SUPABASE_PROJECT_REF}\\.supabase\\.co`, 'g'), CUSTOM_DOMAIN)
      .replace(/https:\/\/[a-z]+\.supabase\.co/g, `https://${CUSTOM_DOMAIN}`);
  }

  // Handle Error objects
  if (error instanceof Error) {
    const sanitizedError = new Error(
      sanitizeError(error.message)
    );
    sanitizedError.name = error.name;
    sanitizedError.stack = error.stack?.replace(
      new RegExp(`${SUPABASE_PROJECT_REF}\\.supabase\\.co`, 'g'),
      CUSTOM_DOMAIN
    );
    return sanitizedError;
  }

  // Handle objects (like Supabase error responses)
  if (typeof error === 'object') {
    const sanitized: any = Array.isArray(error) ? [] : {};

    for (const key in error) {
      if (error.hasOwnProperty(key)) {
        sanitized[key] = sanitizeError(error[key]);
      }
    }

    return sanitized;
  }

  return error;
}

/**
 * Sanitizes console.error to hide Supabase URLs
 * Call this once during app initialization
 */
export function setupErrorSanitization() {
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;
  const originalConsoleLog = console.log;

  console.error = (...args: any[]) => {
    originalConsoleError(...args.map(sanitizeError));
  };

  console.warn = (...args: any[]) => {
    originalConsoleWarn(...args.map(sanitizeError));
  };

  // Optionally sanitize console.log in production only
  if (import.meta.env.PROD) {
    console.log = (...args: any[]) => {
      originalConsoleLog(...args.map(sanitizeError));
    };
  }
}
